export default "__VITE_ASSET__O3IH9cag__"